import { createSlice } from '@reduxjs/toolkit';

import { TopicOption } from '../../../pages/ProgrammingTest';
import { startTestApi } from '../../../services/startTestAPI/startTestApi';

type ProgrammingState = {
  overallResult: any[];
  resultById: any | null;
  selectedOption: TopicOption | null;
};

const initialState: ProgrammingState = {
  overallResult: [],
  resultById: null,
  selectedOption: null
};
const programming = createSlice({
  name: 'programming',
  initialState,
  reducers: {
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      startTestApi.endpoints.getProgrammingUserTests.matchFulfilled,
      (state, action) => {
        state.overallResult = action.payload.data;
      }
    );
    builder.addMatcher(
      startTestApi.endpoints.getProgrammingUserTestById.matchFulfilled,
      (state, action) => {
        state.resultById = action.payload.data;
      }
    );
  }
});

export const { setSelectedOption } = programming.actions;
export default programming.reducer;
